import MobileProfile from "../components/mobileProfile";
import MenuBarSmartf from "../components/menu-bar-smartf";



export default function AccountSettings (){
    return(
        <div>
            <MobileProfile/>
            <MenuBarSmartf/>
        </div>
    )
}